export default function sendWindowMessage<T>(message: T) {
  window.parent.postMessage(message, '*');
}
